import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';

export class EditionNameForm extends Component {
    renderHelpBlock(inputError) {
        if (null === inputError) {
            return null;
        }

        return (<HelpBlock>Este campo não pode estar vazio.</HelpBlock>);
    }

    render() {
        const { title, value, inputError } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={inputError} >
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={value}
                                placeholder="Introduza o Nome"
                                onChange={this.props.onChangeValue}
                            />
                            {this.renderHelpBlock(inputError)}
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={this.props.onSave}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={this.props.onHide}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
